<section class="titleS">
    <h1>Brazi si pini</h1>
</section>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/abiesAlba.jpg" class="img-fluid" alt="Douglas">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad</h1>
                                <p>Abies Alba</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Se planteaza solitar sau in grupuri.</p>
                        <p>Plantarea se face in perioada de repaus vegetativ 15 noiembrie-10 martie cu conditia ca solul
                            sa nu fie inghetat.</p>
                        <p>Bradul Abis Alba soi romanesc, gasit indeosebi in padurile muntilor Carpati.</p>
                        <p>Vegeteaza bine in soluri variate, dar le prefera pe cele fertile si bine drenate.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Abies Alba</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>200-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>2000-2500</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/piceapungens.jpg" class="img-fluid" alt="piceapungens">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad</h1>
                                <p>Picea pungens</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Picea Pungens este un molidul argintiu de talie medie ce poate ajunge la 10-12m.</p>
                        <p>Are o forma conica simetrica, ramuri cu ace lungi, rigide de culoare albastra-argintie. Este
                            un conifer cu crestere lenta, cu o rata de crestere anuala de 10-15 cm si face conuri mari.
                            Se dezvolta bine in plin soare si isi mentine culoarea tropicala. Se dezvolta bine pe soluri
                            calcaroase, iar necesarul de apa este mediu. Acest soi este foarte decorativ, putand fi pus
                            in evidenta ca exemplar solitar. Rezistent la ger, pentru plantare se alege o pozitie
                            insorita. Tolereaza caldura si vantul. Bun pentru mediul urban, fiind rezistent la poluare.
                        </p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Picea pungens</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>1000-1200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/daisywhite.jpg" class="img-fluid" alt="daisywhite">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad(Picea Glauca)</h1>
                                <p>Daisy White</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un molid pitic, foarte atragator, cu forma conica compacta, foliaj foarte dens.</p>
                        <p>Este special prin culoarea galben-aurie a mugurilor care imbraca planta in primavara
                            oferindu-i un aspect foarte luminos si pufos.</p>
                        <p>In decurs de 4-6 saptamani de la aparitia lor, acele isi schimba culoarea in alb verde si
                            apoi verde inchis si devin rigide, tepoase.</p>
                        <p>Este potrivit pentru gradini mici, dar creste foarte bine si in ghivece pe terase.</p>
                        <p>Se planteaza in plin soare, prefera solurile acide, bine drenate, are crestere foarte
                            inceata.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad(Picea Glauca)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Daisy White</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>25-40</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/piceaglaucaconica.jpg" class="img-fluid" alt="piceaglaucaconica">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad(Picea Glauca)</h1>
                                <p>Glauca Conica</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un conifer superb cu o coroana deasa si bogata. Frunzele nou crescute sunt moi si
                            subtiri, de culoare verde-deschis.</p>
                        <p>Are portul conic. Este cunoscut si sub denumirea de molid conic. Are numeroase intrebuintari
                            peisagistice si arata bine in foarte multe spatii.</p>
                        <p>Se foloseste ca planta solitara sau în aliniamente. Cresterea e relativ lenta, dar acest
                            arbust rasinos ofera frumusete gradinilor la orice varsta.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad(Picea Glauca)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Glauca Conica</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>150-200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/Piceaomorikanana.jpg" class="img-fluid" alt="piceaglaucaconica">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad(Picea)</h1>
                                <p>OmorikaNana</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>O formă frumoasă și compactă a molidului sârbesc, această selecție are ace de culoare verde închis cu benzi stomatice albe pe partea inferioară, care conferă plantei o aură argintie distinctivă.</p>
                        <p>Forma sa este densă și globoasă când este tânără, dar se dezvoltă într-o piramidă largă dramatică odată cu vârsta.</p>
                        <p>Se foloseste ca planta solitara sau în aliniamente. Cresterea e relativ lenta, dar acest
                            arbust rasinos ofera frumusete gradinilor la orice varsta.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad(Picea)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Omorika Nana</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 150cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200-250</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>400</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/abiesnordmanniana.jpg" class="img-fluid" alt="abiesnordmanniana">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Brad</h1>
                                <p>Abies Nordmanniana</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Bradul Nordmann este cel mai popular pom de Craciun.</p>
                        <p>Se planteaza solitar sau in grupuri.</p>
                        <p>Plantarea se face in perioada de repaus vegetativ 15 noiembrie-10 martie cu conditia ca solul
                            sa nu fie inghetat.</p>
                        <p>Bradul Nordmann este o specie cu temperament de lumina, dar suporta si semiumbra.</p>
                        <p>Vegeteaza bine in soluri variate, dar le prefera pe cele fertile si bine drenate.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Brad</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Abies Nordmanniana</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>2500</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Noiembrie-Martie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<!--Pin  -->
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/pinusmugo.jpg" class="img-fluid" alt="pinusmugo">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Pin</h1>
                                <p>Mugo</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Pinii sunt copaci superbi ce pot fi intalniti oriunde de la tarile nordice pana la coastele
                            fierbinti. Probabil cele mai frumoase exemplare se gasesc in mediul lor natural, insa
                            acestea pot fi adevarate bijuterii oriunde, daca ii sunt create conditiile optime de
                            dezvoltare. Pinus mugo este o varietate de pin pitic, cu o crestere compacta si lenta.
                            Formeaza un tufis bogat, mai mult lat decat inalt, cu ace mai scurte de un verde inchis.
                            Arata excelent in gradini cu stancarii, gradini japoneze. Pinii au nevoie de sol usor umed
                            atunci cand se stabilesc, dupa transplantare, dar vor suporta orice sol bine drenat. Pentru
                            a se ramifica si imbogatii, are nevoie de mult soare, asa ca incercati sa ii gasiti un loc
                            cat mai însorit. Complet rezistent pana la -45 grade Celsius.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Pin</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Mugo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>30-50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Februarie-Aprilie, Septembrie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/pinus_sylvestris.jpg" class="img-fluid" alt="pinusmugo">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Pin</h1>
                                <p>Sylvestris</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Pinus Sylvestris, cunoscut ca pinul de pădure este o specie de pin nativ european.
                           Este unul dintre cele mai frumoase și mai neobișnuite exemplare din fauna europeană.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Pin</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Sylvestris</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>70-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>2000</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Februarie-Aprilie, Septembrie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/pinuscembra.jpeg" class="img-fluid" alt="pinusmugo">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Pin</h1>
                                <p>Cembra</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Pinus cembra sau Zambrul este un conifer ce creste si in tara la noi in stare naturala in muntii Rodnei. Este o specie de pin ce creste in muntii Alpi si in Carpati.
                           Zambrul face parte din categoria pinilor albi. Frunzele sale sunt sub forma de ace ce cresc cate cinci, grupate in fascicule.
                           Aceasta specie prezinta conuri ce au o marime de 5 cm, in interiorul acestora se regasesc semintele ce ajuta la raspandirea acestui soi de conifer.
                           Este un arbore extrem de rezistent la conditiile aspre de mediu, la vant puternic datorita radacinii pivotante
                           Se recomanda cultivarea Zambrului in zonele cu lumina si semi-umbra, poate fi plantat in soluri lutoase, nisipoase, pietroase.
                           Pinus cembra creeaza un aspect impresionant in gradini si spatii verzi, datorita formei sale conice naturale si a crengilor cu varful indreptat inspre partea superioara.
                           El impodobeste cu gratie fiecare spatiu verde. Arata impresionant si ca pom de craciun.
                           Pe langa aspectul decorativ, acest conifer este recunoscut pentru beneficile sale asupra sanatatii.
                           Petrecerea timpului in apropierea acestuia ajuta la inducerea unui somn linistit si a relaxarii datorita cantitatii de oxigen emanate.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Pin</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cembra</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>500-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>350</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Februarie-Aprilie, Septembrie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec" id="ultim">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/brazi/pinnigra.jpg" class="img-fluid" alt="pinnigra">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Pin</h1>
                                <p>Nigra</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Cunoscut si sub numele de Pin negru, este o specie de conifer originar din Europa Centrala si
                            de Sud. Are o rezistenta sporita la ger si seceta, nepretentios fata de sol si iubeste
                            lumina. Coroana are un aspect piramidal, acest pin face parte din categoria pinilor cu doua
                            ace intr-o teaca. Conurile au dimensiuni de 4-7 cm lungime si sunt indreptate in sus, in
                            tinerete sunt verzi, iar la maturitate se coloreaza in brun-maroniu. Se planteaza ca arbore
                            ornamental in gradini, orase, parcuri.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Pin</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Nigra</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>3000-4000</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>1/cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Februarie-Aprilie, Septembrie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>